<template>
  <div class="company-form">
    <div class="card">
      <div>
        <div v-if="isPreloader" class="table-preloader">
          <preloader />
        </div>
        <a-form v-else layout="vertical" :model="form" @finish="submitOrganization">
          <div class="company-form__inputs">
            <div class="company-form__area company-form__area1">
              <a-form-item label="Наименование компании*" name="name" :rules="[{ required: true, message: 'Введите наименование компании' }]">
                <a-input v-model:value="form.name" :disabled="!getRight('companyEdit')" />
              </a-form-item>

              <a-form-item label="ИНН*" name="inn" :rules="[{ required: true, message: 'Введите ИНН' }]">
                <a-input v-model:value="form.inn" :mask="'############'" :disabled="!getRight('companyEdit')" />
              </a-form-item>

              <a-form-item  v-if="getRight('companyDistribution')" label="Администратор" name="owner_id">
                <a-select
                    v-model:value="form.owner_id"
                    show-search
                    allow-clear
                    :placeholder="'Не выбрано'"
                    :not-found-content="usersLoading ? 'Поиск…' : 'Нет данных'"
                    :loading="usersLoading"
                    :filter-option="false"
                    :options="userOptions"
                    @search="debouncedSearch"
                    @clear="clearUsers"
                    class="select-users"
                    :show-arrow="true"
                />
              </a-form-item>

              <a-form-item label="WWW-страница" name="site">
                <a-input v-model:value="form.site" :disabled="!getRight('companyEdit')" />
              </a-form-item>
            </div>

            <div class="company-form__area company-form__area2 display--flex justify-content-center align-item-center">
                <div>
                  <a-image
                      v-if="logoSource"
                      :width="200"
                      :height="200"
                      :preview="false"
                      :src="logoSource"
                      style="background-color: var(--neutral-grey)"
                  />

                  <div v-else class="logo-placeholder">
                    <UserOutlined />
                    <span>Нет логотипа</span>
                  </div>
                </div>

                <div class="upload-button">
                  <a-upload
                      :before-upload="handleBeforeUpload"
                      :show-upload-list="false"
                      accept="image/*"
                  >
                    <a-button class="secondary-button">
                      <UploadOutlined/>
                      Загрузить логотип компании
                    </a-button>
                  </a-upload>
                </div>
            </div>

            <div class="company-form__area company-form__area3">
              <a-form-item label="Направление деятельности" name="direction_of_activity">
                <a-input v-model:value="form.direction_of_activity" :disabled="!getRight('companyEdit')" />
              </a-form-item>

              <a-form-item label="Телефон" name="phone">
                <a-input v-model:value="form.phone" type="tel" :disabled="!getRight('companyEdit')" />
              </a-form-item>

              <a-form-item label="Вид организации" name="organization_type">
                <a-input v-model:value="form.organization_type" :disabled="!getRight('companyEdit')" />
              </a-form-item>

              <a-form-item label="КПП" name="kpp">
                <a-input v-model:value="form.kpp" :mask="'#########'" :disabled="!getRight('companyEdit')" />
              </a-form-item>

              <a-form-item name="request_survey">
                <a-checkbox v-model:checked="form.request_survey">
                  Запрашивать анкету при тестировании
                </a-checkbox>
              </a-form-item>
            </div>

            <div class="company-form__area company-form__area4">
              <a-form-item label="ОГРН" name="ogrn">
                <a-input v-model:value="form.ogrn" :mask="'#############'" :disabled="!getRight('companyEdit')" />
              </a-form-item>

              <a-form-item label="Юр. Адрес" name="legal_address">
                <a-input v-model:value="form.legal_address" :disabled="!getRight('companyEdit')" />
              </a-form-item>

              <a-form-item label="Краткое название компании (для документов)" name="legal_short_name">
                <a-input v-model:value="form.legal_short_name" :disabled="!getRight('companyEdit')" />
              </a-form-item>

              <a-form-item label="Полное название компании (для документов)" name="legal_full_name">
                <a-input v-model:value="form.legal_full_name" :disabled="!getRight('companyEdit')" />
              </a-form-item>
            </div>

            <div v-if="getRight('companyAnalyticsAccess')">
              <a-form-item label="Доступ к аналитике компании" name="analytics">
                <a-select
                    v-model:value="selectedAnalyticsAllowedUsers"
                    show-search
                    allow-clear
                    mode="multiple"
                    :placeholder="'Не выбрано'"
                    :not-found-content="usersLoading ? 'Поиск…' : 'Нет данных'"
                    :loading="usersLoading"
                    :filter-option="false"
                    :options="userOptions"
                    @search="debouncedSearch"
                    @clear="clearUsers"
                    class="select-users"
                    :show-arrow="true"
                />
              </a-form-item>
            </div>
          </div>

          <div
              v-if="getRight('companyEdit')"
              class="
              company-form__btns
            "
          >
            <a-button @click="router.go(-1)" class="secondary-button">
              Назад
            </a-button>
            <a-button html-type="submit" class="primary-button" :loading="formLoading">
              Сохранить
            </a-button>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
import useErrors from "../../mixins/useErrors";
import { reactive, ref } from "@vue/reactivity";
import PreviewFileLoader from "./Fields/PreviewFileLoader.vue";
import standartError from "../../mixins/standartError";
import {
  computed, inject,
  onBeforeMount,
  onBeforeUnmount,
  watch,
} from "@vue/runtime-core";
import useCheckRights from "../../mixins/useCheckRights";
import { useRoute, useRouter } from "vue-router";
import Preloader from "../Technical/Preloader.vue";
import useAjaxSelect from "@/mixins/useAjaxSelect";
import CustomSelect2 from "./Fields/CustomSelect2.vue";
import $ from "jquery";
import debounce from "@/mixins/debounce";
import {message} from "ant-design-vue";
import {UploadOutlined, UserOutlined} from "@ant-design/icons-vue";

export default {
  components: {UserOutlined, UploadOutlined, PreviewFileLoader, Preloader, CustomSelect2 },
  name: "company-form",
  setup() {
    const store = useStore(),
        {setErrors, clearCustomErrors} = useErrors(),
        {getRight} = useCheckRights(),
        route = useRoute(),
        router = useRouter(),
        selectedAnalyticsAllowedUsers = ref([]),
        isPreloader = ref(false),
        formLoading = ref(false);

    const {usersAjax} = useAjaxSelect();

    let form = reactive({
      name: "",
      site: "",
      direction_of_activity: "",
      phone: "",
      organization_type: "",
      inn: "",
      kpp: "",
      ogrn: "",
      legal_address: "",
      legal_short_name: "",
      legal_full_name: "",
      image: null,
      currentImage: null,
      owner_id: null,
      request_survey: null,
    });

    const currentCompany = computed(() => store.state.company.userCompany),
        company = computed(() => store.state.company.company),
        numberUserId = computed(() =>
            form.owner_id ? Number(form.owner_id) : null
        ),
        isCreateAdminNewCompany = computed(
            () => route.path === "/company/create"
        );

    const analyticsAllowedUsers = computed(() => store.state.company.analyticsAllowedAccessUsers);

    onBeforeMount(() => {
      if (route.params.id) {
        fetchCompany();
        return;
      }
      if (!isCreateAdminNewCompany.value) {
        isPreloader.value = true;
        store.dispatch("company/getUserCompany").then(() => {
          Object.assign(form,
              {
                ...currentCompany.value,
                owner_id: currentCompany.value.owner_id
                    ? String(currentCompany.value.owner_id)
                    : null,
              }
          );

          isPreloader.value = false;
        });
      }
    });

    onBeforeUnmount(() => {
      store.commit("company/setCompany", null);
      store.commit("company/setUserCompany", null);
      store.commit("company/setAnalyticsAllowedAccessUsers", null);
    });

    const fetchCompany = () => {
        isPreloader.value = true;
        store.dispatch("company/getAnalyticsAccessUsers", route.params.id).then(() => {
          fillUsers();

          selectedAnalyticsAllowedUsers.value = analyticsAllowedUsers.value.map((el) => String(el.id));
        });

        store.dispatch("company/getCompany", route.params.id).then(() => {
          fillUsers();

          Object.assign(form,
              {
                ...company.value,
                owner_id: company.value.owner_id
                    ? String(company.value.owner_id)
                    : null,
              }
          );
          isPreloader.value = false;
        });
    }

    const submitOrganization = () => {
      if (
          (currentCompany.value && Object.keys(currentCompany.value).length) ||
          (company.value && Object.keys(company.value).length)
      ) {
        formLoading.value = true;
        saveAnalyticsSettings();
        store
            .dispatch("company/updateCompany", {
              id: route.params.id ? company.value.id : currentCompany.value.id,
              company: {...form, owner_id: numberUserId.value},
            })
            .then(() => {
              store.commit("setCompanyTrap", false);
              message.success('Данные обновлены');
              fetchCompany();
              router.push('/');
              }
            )
            .catch(() => {
              message.error('Произошла ошибка');
            })
            .finally(() => {
              formLoading.value = false;
            })

        return;
      }

      formLoading.value = true;
      store
          .dispatch("company/createCompany", {
            ...form,
            owner_id: numberUserId.value,
          })
          .then(() => {
            store.commit("setCompanyTrap", false);
            message.success('Данные обновлены');

            if (isCreateAdminNewCompany.value) {
              router.push("/organizations");
            }
          })
          .catch(() => {
            message.error('Произошла ошибка');
          })
          .finally(() => {
            formLoading.value = false;
          })
    };

    watch(
        () => route.params.id,
        () => {
          if (route.params.id) {
            isPreloader.value = true;
            store.dispatch("company/getCompany", route.params.id).then(() => {
              Object.assign(form, company.value);
              form.owner_id = company.value.owner_id ? String(company.value.owner_id) : null;
              isPreloader.value = false;
            });
            return;
          }
          if (route.path !== "/company/create") {
            isPreloader.value = true;
            store.dispatch("company/getUserCompany").then(() => {
              Object.assign(form, company.value);
              form.owner_id = company.value.owner_id ? String(company.value.owner_id) : null;
              isPreloader.value = false;
            });
            return;
          }
        }
    );

    const saveAnalyticsSettings = () => {
      store.dispatch("company/setAnalyticsAccessUsers",
          {
            id: route.params.id,
            users: selectedAnalyticsAllowedUsers,
          });
    }

    const usersLoading = ref(false);
    const userOptions = ref([]);

    let currentSearchRequest = ref(0);
    const foundUsers = computed(() => store.state.users.foundUsers);

    const searchForUsers = async (query) => {
      fillUsers();

      if (!query || query.length < 3) return;

      let requestNumber = ++currentSearchRequest.value;
      usersLoading.value = true;

      userOptions.value = [];

      store.dispatch('users/searchByName', query).then(() => {
        if (requestNumber !== currentSearchRequest.value) return;

        const uniqueNew = foundUsers.value
            .filter(u => !userOptions.value.some((opt) => {
              return u.id === opt.value;
            }))
            .map(u => ({
              value: u.id,
              label: `${u.name} (${u.email})`,
            }));

        userOptions.value.push(...uniqueNew);
        usersLoading.value = false
      });
    }

    const debouncedSearch = debounce(searchForUsers, 350);

    const clearUsers = () => {
      fillUsers();
    }

    const fillUsers = () => {
      let analyticOptions = [];
      let companyOptions = [];

      if (analyticsAllowedUsers.value) {
        analyticOptions = analyticsAllowedUsers.value?.map(user => {
          return {
            value: String(user.id),
            label: `${user.name} (${user.email})`,
          }
        });
      }

      if (company.value) {
        companyOptions = [{
          value: String(company.value.owner_id),
          label: `${company.value.owner_name}`,
        }];
      }

      userOptions.value = [
          ...analyticOptions,
          ...companyOptions,
      ];
    }

    const handleBeforeUpload = async (file) => {
      let tempImage =  await fileToBase64(file);
      form.currentImage = tempImage;
      form.image = tempImage;
      return false;
    };

    const imageUrl = inject("imageUrl");

    const logoSource = computed(() => {
      if (form.image && !form.currentImage) {
        return `${imageUrl}/storage/${form.image}`;
      } else if (form.currentImage) {
        return form.currentImage;
      } else {
        return undefined;
      }
    });

    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });

    watch([company, analyticsAllowedUsers], () => {
      fillUsers();
    }, { immediate: true });

    return {
      form,
      submitOrganization,
      currentCompany,
      getRight,
      router,
      isPreloader,
      company,
      usersAjax,
      selectedAnalyticsAllowedUsers,
      analyticsAllowedUsers,
      clearUsers,
      usersLoading,
      userOptions,
      debouncedSearch,
      handleBeforeUpload,
      logoSource,
      formLoading
    };
  },
};
</script>

<style lang="scss" scoped>
.company-form {
  &__inputs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 25px;

    @media (max-width: 1480px) {
      grid-template-columns: 1fr;
    }
  }

  .company-form__btns {
    display: flex;
    gap: 8px;
    justify-content: flex-end;

    @media (max-width: $mobile-breakpoint) {
      flex-direction: column;
    }
  }

  .company-form__area2 {
    margin: 0 0 12px;
    gap: 8px;

    @media (max-width: $mobile-breakpoint) {
      flex-direction: column;
    }

    :deep(.ant-image-img) {
      object-fit: contain;
    }
  }

  .logo-placeholder {
    width: 200px;
    height: 200px;
    background: var(--light-grey);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 14px;
  }

  :deep(.ant-form-item) {
    margin-bottom: 12px;
  }
}
</style>